import React from "react";
import { Row, Col } from "reactstrap";

function get(obj, path, fallback) {
  var result = obj;
  var parts = path.split(".");
  for (var i = 0; i < parts.length; i++) {
    if (result === null || result === undefined) return fallback;
    result = result[parts[i]];
  }
  return result === undefined || result === null ? fallback : result;
}

function normalizeImages(val) {
  if (!val) return [];
  if (Array.isArray(val)) {
    return val
      .map((item) => {
        if (typeof item === "string") return item;
        if (typeof item === "object") {
          return item.media_location || item.link || item.url || null;
        }
        return null;
      })
      .filter(Boolean);
  }
  return [];
}

function renderValue(val) {
  if (val === null || val === undefined || val === "") return <span className="text-muted">-</span>;

  if (Array.isArray(val)) {
    if (val.length === 0) return <span className="text-muted">-</span>;
    if (typeof val[0] === "object") {
      return val.map((obj, i) => (
        <div key={i} className="mb-1">
          {Object.entries(obj).map(([k, v]) => (
            <div key={k}>
              <b>{k}:</b> {String(v)}
            </div>
          ))}
        </div>
      ));
    }
    return val.join(", ");
  }

  if (typeof val === "object") {
    return Object.entries(val).map(([k, v]) => (
      <div key={k}>
        <b>{k}:</b> {String(v)}
      </div>
    ));
  }

  return String(val);
}

function AmazonProductListingPreview({ groupedFields, changedFields = {} }) {
  if (!groupedFields || Object.keys(groupedFields).length === 0) {
    return <div className="p-3 text-center">No preview data available.</div>;
  }

  return (
    <div className="preview-mode-wrapper">
      <div className="preview-mode-content p-4">
        {Object.keys(groupedFields).map((group, groupIndex) => {
          const fields = groupedFields[group];
          if (!fields || fields.length === 0) return null;

          return (
            <div key={group} className="preview-group mb-5">
              
              <h4 className="preview-group-title" style={{ fontWeight: 'bold', marginBottom: '20px' }}>
                {group} :
              </h4>
              
              <Row className="g-3">
                {fields.map((f, index) => {
                  const label = f.label || f.field || "Unknown Field";
                  const isImageField = f.field === "images" || (f.field && f.field.includes("image_locator")) || (f.ui && f.ui.input_type === "image");
                  
                  const oldVal = get(f, "listing.value", null);

                  const isUpdated = changedFields.hasOwnProperty(f.field);
                  const newVal = isUpdated ? changedFields[f.field].value : oldVal;

                  return (
                    <Col md={12} key={index} className="mb-4">
                      
                      <div className="preview-question-label" style={{ fontWeight: 'bold', color: '#555', marginBottom: '8px' }}>
                        {label}?
                      </div>
                      
                      <div className="answer-value">
                        {isImageField ? (
                          <div className="d-flex flex-wrap pl-3" style={{ paddingLeft: '16px' }}>
                            <span className="preview-answer-arrow mt-1" style={{ marginRight: '8px' }}>&#8594;</span>
                            {normalizeImages(newVal).length > 0 ? (
                              normalizeImages(newVal).map((img, i) => (
                                <img key={i} src={img} alt="preview" className="preview-image-item" style={{ maxWidth: '100px', marginRight: '10px' }} />
                              ))
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </div>
                        ) : (
                          <div className="d-flex flex-column">
                            {isUpdated ? (
                              <>
                                <div className="preview-old-value" style={{ color: '#999', fontSize: '13px', paddingLeft: '24px', marginBottom: '4px' }}>
                                  {renderValue(oldVal)}
                                </div>
                                
                                <div className="preview-new-value-container" style={{ backgroundColor: '#B2FFFF', padding: '6px 12px', borderRadius: '4px', display: 'flex', alignItems: 'center', color: '#000' }}>
                                  <span className="preview-answer-arrow" style={{ marginRight: '8px' }}>&#8594;</span> 
                                  <span className="preview-value-text">{renderValue(newVal)}</span>
                                </div>
                              </>
                            ) : (
                              <div className="d-flex align-items-center" style={{ paddingLeft: '8px', color: '#333' }}>
                                <span className="preview-answer-arrow" style={{ marginRight: '8px' }}>&#8594;</span> 
                                <span className="preview-value-text">{renderValue(oldVal)}</span>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AmazonProductListingPreview;